import { retrieveAccountOrigin, retrieveGCLID, retrieveUtm } from '../../utils';
var RetrievalUtils = /** @class */ (function () {
    function RetrievalUtils() {
    }
    RetrievalUtils.retrieveUtm = function (leadData) {
        return retrieveUtm(leadData);
    };
    RetrievalUtils.retrieveGCLID = function (accountOrigin) {
        return retrieveGCLID(accountOrigin);
    };
    RetrievalUtils.retrieveAccountOrigin = function (leadData) {
        return retrieveAccountOrigin(leadData);
    };
    return RetrievalUtils;
}());
export { RetrievalUtils };
//# sourceMappingURL=index.js.map